import React, { useState } from "react";
import { Container } from "reactstrap";
import { PageHeader } from "../../../CommonElements/PageTitle";
import { HousingInspectionOrders } from "./HousingInspectionOrders";
import { Tabs } from "antd";
import { useTranslation } from "react-i18next";

const HousingInspectionOrder = () => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState("active");

  const items = [
    {
      key: "all",
      label: t("ALL"),
      children: <></>,
    },
    {
      key: "active",
      label: t("ACIVE_ORDERS"),
      children: <></>,
    },
    {
      key: "inactive",
      label: t("INACTIVE_ORDERS"),
      children: <></>,
    },
  ];



  return (
    <div>
      <PageHeader sticky={false} />
      <Container fluid>
        <Tabs items={items} activeKey={activeTab} onChange={setActiveTab} />
        <HousingInspectionOrders activeTab={activeTab} />
      </Container>
    </div>
  );
};

export default HousingInspectionOrder;
